export const XRPIcon = () => {
  return (
    <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 60C13.4306 60 0 46.5694 0 30C0 13.4306 13.4306 0 30 0C46.5694 0 60 13.4306 60 30C60 46.5694 46.5694 60 30 60ZM43.2563 15L34.68 23.4806C33.4322 24.7122 31.7495 25.4028 29.9963 25.4028C28.243 25.4028 26.5603 24.7122 25.3125 23.4806L16.7437 15H11.3156L22.6031 26.1694C24.5749 28.1121 27.2319 29.2011 30 29.2011C32.7681 29.2011 35.425 28.1121 37.3969 26.1694L48.6769 15H43.2563ZM16.6781 46.0556L25.32 37.5C26.5678 36.2684 28.2505 35.5778 30.0037 35.5778C31.757 35.5778 33.4397 36.2684 34.6875 37.5L43.3219 46.0556H48.75L37.3969 34.8187C35.425 32.876 32.7681 31.787 30 31.787C27.2319 31.787 24.5749 32.876 22.6031 34.8187L11.25 46.0537L16.6781 46.0556Z"
        fill="white"
      />
    </svg>
  );
};
